import { useMutation } from "@shared/lib/hooks";
import { ToastService } from "@shared/lib/services";
import { IRemoveDefaultPricicingPocRequest } from "@shared/lib/types/brief";
import { BriefService } from "../services/brief.service";
import { setBriefByIdQueryData } from "./useGetBriefById";

export function useRemovePricingPocFromBrief() {
  const {
    mutate: removePricingPocFromBrief,
    isLoading: isRemovingPricingPocFromBrief,
    isSuccess: isRemovedPricingPocFromBrief,
  } = useMutation({
    mutationFn: (data: IRemoveDefaultPricicingPocRequest) =>
      BriefService.removePricingPoc(data).catch(async (err) => {
        const responseBody = await err.response.json();
        ToastService.error(responseBody.msg);
        throw err;
      }),
    options: { skipInvalidation: true },
    onSuccess: (queryClient, response, variables) => {
      ToastService.success("Pricing POC removed successfully");
      setBriefByIdQueryData(queryClient, variables.briefId, response);
    },
  });

  return {
    removePricingPocFromBrief,
    isRemovingPricingPocFromBrief,
    isRemovedPricingPocFromBrief,
  };
}
